import { useEffect, useState } from "react";
import { Link } from "wouter";
import { UserCircle } from "lucide-react";
import { GlobalSearch } from "@/components/ui/global-search";

interface DashboardHeaderProps {
  title: string;
  profileLink: string;
}

export function DashboardHeader({ title, profileLink }: DashboardHeaderProps) {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  useEffect(() => {
    fetch("/api/user/profile", { credentials: "include" })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.profilePhotoUrl) setAvatarUrl(data.profilePhotoUrl); })
      .catch(() => {});
  }, []);

  return (
    <header className="bg-white border-b border-slate-200 h-16 flex items-center px-8 sticky top-0 z-10">
      <h1 className="text-xl font-semibold text-slate-800 w-64 shrink-0">{title}</h1>
      <div className="flex-1 flex justify-center">
        <div className="w-full max-w-md">
          <GlobalSearch />
        </div>
      </div>
      <Link href={profileLink} className="shrink-0" title="Your profile">
        {avatarUrl ? (
          <img src={avatarUrl} alt="" className="size-[60px] rounded-full object-cover border-2 border-slate-200 hover:border-teal-400 transition-colors" />
        ) : (
          <div className="size-[60px] rounded-full bg-teal-100 flex items-center justify-center border-2 border-slate-200 hover:border-teal-400 transition-colors">
            <UserCircle className="h-8 w-8 text-teal-600" />
          </div>
        )}
      </Link>
    </header>
  );
}
